import { InitializeOptions } from "@vm/tableau";

export default {
  config: {
    route: "/editor",
    dialogOptions: {
      dialogStyle: "modal",
      height: 800,
      width: 1000,
    },
  },
  tableauApi: {
    version: "1.16.0",
  },
} satisfies InitializeOptions;
